import React from "react";
import { Switch, Route, Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
import Style from "./App.module.css";
import Home from "./pages/userPage/home/Home";
import About from "./pages/userPage/about/About";
import Skills from "./pages/userPage/skills/Skills";
import Projects from "./pages/userPage/projects/Projects";
import Contact from "./pages/userPage/contact/Contact";
import NavigationBar from "./components/navbar/NavBar";
import PageTop from "./components/pagetop/PageTop";

function App() {
  return (
    <div className={Style.body}>
      <Switch>
        <div className={Style.pagecolumns}>
          <div className={Style.nav}>
            <NavigationBar />
          </div>
          <div className={Style.page}>
            <div className={Style.pageheader}>
              <PageTop />
            </div>
            <Route exact path={["/", "/home"]} component={Home} />
            <Route exact path={"/about"} component={About} />
            <Route exact path={"/skills"} component={Skills} />
            <Route exact path={"/projects"} component={Projects} />
            <Route exact path={"/contact"} component={Contact} />
          </div>
        </div>
      </Switch>
    </div>
  );
}

export default App;
